<template>
  <div id="nlu-app">
    <ServiceNavigation />
    <ExpirationOverlay
      :lock-username="lockScreenUsername"
      :username="username"
      :auth-url="authUrl"
      :identity-provider="identityProvider"
      :token="token"
      :user-id="userId"
      :account-id="accountId"
      :cookies-expired="cookiesExpired"
      :cookies-another-user="cookiesAnotherUser"
      :cookies-no-rights="cookiesNoRights"
      :login-overlay-disabled="false"
      @onUpdateCookieExpiration="cookiesRenewHandler"
    />
    <darkMode />
    <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import config from './config'
import authService from './api/auth'
// eslint-disable-next-line import/no-unresolved
import { ExpirationOverlay } from '@onereach/auth-ui-module/dist/vue2/index'
import darkMode from './components/common/dark_mode'
import ServiceNavigation from '@/app/components/ServiceNavagation'

export default {
  components: {
    darkMode,
    ServiceNavigation,
    ExpirationOverlay
  },

  computed: {
    ...mapState({
      username: ({ auth }) => auth.username,
      identityProvider: ({ auth }) => auth.identityProvider,
      token: ({ auth }) => auth.token,
      userId: ({ auth }) => auth.userId,
      accountId: ({ auth }) => auth.accountId,
      cookiesExpired: ({ auth }) => auth.cookiesExpired,
      cookiesAnotherUser: ({ auth }) => auth.cookiesAnotherUser,
      cookiesNoRights: ({ auth }) => auth.cookiesNoRights,
      authorized: ({ auth }) => auth.authorized,
      auth: ({ auth }) => auth
    })
  },

  mounted () {
    axios.interceptors.response.use(
      response => response,
      async error => {
        if (error.isAxiosError && error.response && error.response.status === 401) {
          try {
            await this.checkAuthentication()
          } catch (error) {
            this.redirectToAuthPage()
          }
        }
        return Promise.reject(error)
      })
  },

  data () {
    return {
      authUrl: config.AUTH_UI_URL,
      lockScreenUsername: ''
    }
  },

  methods: {
    ...mapActions('auth', ['checkAuthentication', 'redirectToAuthPage']),
    ...mapActions('knowledgebase', ['initNluApplication']),
    ...mapActions('knowledgebase/flows', ['fetchFlows']),
    ...mapActions('knowledgebase/deployments', ['fetchActiveDeployments']),
    ...mapActions('knowledgebase/users', ['fetchUsers']),

    cookiesRenewHandler () {
      authService.updateCookieExpiration()
    }
  },

  watch: {
    async authorized (value) {
      if (value) {
        this.lockScreenUsername = await authService.getUserNameForLockScreen(this.auth)

        this.fetchFlows()
        this.fetchActiveDeployments()
        this.fetchUsers()

        this.initNluApplication()
      }
    }
  }
}
</script>

<style lang="scss" >
* {
  box-sizing: border-box;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
}

div#nlu-app {
  height: 100%;
}
</style>
